"use client";

import { useStudio } from "@/contexts/studio-context";
import { useCallback, useState } from "react";

const SPEED_OPTIONS = [
  { label: "25%", value: 0.25 },
  { label: "50%", value: 0.5 },
  { label: "70%", value: 0.7 },
  { label: "80%", value: 0.8 },
  { label: "100%", value: 1 },
  { label: "120%", value: 1.2 },
];

export const SpeedSelector = () => {
  const { studio } = useStudio();
  const [rate, setRate] = useState(1);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const newRate = parseFloat(e.target.value);
      setRate(newRate);
      studio?.getLocalTransport().setPlaybackRate(newRate);
    },
    [studio]
  );

  return (
    <div
      className="inline-flex items-center gap-1 rounded px-2 py-[3px]"
      style={{ background: "rgba(22, 22, 30, 0.9)" }}
    >
      <label
        className="text-[10px] font-medium"
        style={{ color: "#606075" }}
      >
        Speed
      </label>
      <select
        value={rate}
        onChange={handleChange}
        className="bg-transparent border-none text-[11px] font-semibold cursor-pointer outline-none font-[inherit]"
        style={{ color: "#f0f0f5" }}
      >
        {SPEED_OPTIONS.map((opt) => (
          <option
            key={opt.value}
            value={opt.value}
            style={{ background: "#16161e" }}
          >
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
